/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from '@reduxjs/toolkit';

import { InjectedReducersType } from 'utils/types/injector-typings';

import vendorReducer from './vendorSlice';
import eventPageReducer from '../app/pages/EventDetailsPage/slice';
import ticketSaleReducer from '../app/pages/TicketSalePage/slice';
import cartReducer from './cartSlice';
import userReducer from './userSlice';
import { eventsApiSlice } from './events/eventsApiSlice';
import seatingChartReducer from './seatingChart';

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
export function createReducer(injectedReducers: InjectedReducersType = {}) {
  const rootReducer = combineReducers({
    vendor: vendorReducer,
    eventPage: eventPageReducer,
    ticketSale: ticketSaleReducer,
    cart: cartReducer,
    user: userReducer,
    [eventsApiSlice.reducerPath]: eventsApiSlice.reducer,
    seatingChart: seatingChartReducer,
    ...injectedReducers,
  });

  return rootReducer;
}
